import React, { useEffect, useState } from 'react';
import { getTests } from '../../utils/api';

import { Link } from 'react-router-dom';

const Tests = () => {
    const [tests, setTests] = useState([]);

    useEffect(() => {
        const fetchTests = async () => {
            try {
                const data = await getTests();
                // Greife auf das Array der Tests zu
                if (Array.isArray(data.tests)) {
                    // Sortiere die Tests nach Datum in absteigender Reihenfolge
                    const sortedTests = data.tests.sort((a, b) => new Date(b.date) - new Date(a.date));
                    // Nimm nur die ersten 6 Tests
                    setTests(sortedTests.slice(0, 6));
                } else {
                    console.error("Fehler: 'tests' ist kein Array", data);
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchTests();
    }, []);

    const formatDate = (isoString) => {
        // console.log(isoString);
        if (!isoString) return "—"; // Falls null oder undefined, gib einen Platzhalter zurück

        const date = new Date(isoString);
        if (isNaN(date.getTime())) return "Ungültiges Datum"; // Falls das Datum ungültig ist

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${day}.${month}.${year} um ${hours}:${minutes} Uhr`;
    };

    return (
        <>
            <div className='category'>Aktuelle Tests</div>
            <div className='short-tests'>
                {tests.map((test) => (
                    <Link to={`/tests/${test.ID}`} viewTransition>
                        <div key={test.ID} className='test-short'>
                            <img src={`/tests/img/games/${test.image}`} alt={test.titel} title={test.titel}/>
                            <div>
                                <div className='datetime'>
                                    {formatDate(test.created_at)}
                                </div>
                                <div className='title'>
                                    {test.titel}
                                </div>
                                <div className='author'>
                                    {test.author}
                                </div>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>
        </>
    );
};

export default Tests;